import { Value } from 'theme/style'

export default {
  root: {
    borderRadius: Value.BorderRadius,
  }
};
